import { allUpdatesAtom, updatingAtom } from './atoms'
import React, { useMemo } from 'react'
import { NodeBasedUpdates } from '../nodeUpdates/types'
import { Box } from '@mui/material'
import { Table } from 'shared/ui/Table/Table'
import { useDoUpdates, useUpdateAll } from './hooks'
import { ConfirmCommitButton } from 'shared/ui'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'

export function UpdatesTable() {
  const nodeUpdates = useAtomValue(allUpdatesAtom)
  const columns = useMemo(() => {
    return [
      {
        title: 'Update Description',
        width: 100,
        rowContent({ extraInfo }: NodeBasedUpdates) {
          return extraInfo
        },
      },
      {
        title: 'Do It',
        width: 50,
        rowContent(update: NodeBasedUpdates) {
          return <DoUpdateButton update={update} />
        },
      },
    ]
  }, [])

  if (!nodeUpdates?.length) return null
  return (
    <Box>
      <Table
        columns={columns}
        items={nodeUpdates}
        title={`${nodeUpdates.length} To Update`}
        toolBarItems={[<UpdateAllButton key="updateAll" />]}
      />
    </Box>
  )
}

function UpdateAllButton() {
  const doUpdateAll = useUpdateAll()
  const updating = useAtomValue(updatingAtom)
  return (
    <ConfirmCommitButton disabled={updating} onClick={doUpdateAll}>
      Update All
    </ConfirmCommitButton>
  )
}

function DoUpdateButton({ update }: { update: NodeBasedUpdates }) {
  const updating = useAtomValue(updatingAtom)
  const doUpdates = useDoUpdates()
  return (
    <ConfirmCommitButton
      disabled={updating}
      onClick={() => {
        doUpdates(update)
      }}
    >
      DoIt
    </ConfirmCommitButton>
  )
}
